const NAME = "SIGNED_DOCUMENTS_PAGE";

export default NAME;